export class PortalSettingsResponse {
	public portalSettingID: number;
	public portalID: number;
	public code: string;
	public value: string;
}
